import { all } from 'redux-saga/effects';

import authSaga from './auth/sagas';
import casesSaga from './cases/sagas';
import notificationsSaga from './notifications/sagas';
import userSaga from './user/sagas';
import lenderSaga from './lender/sagas';
import dashboardSaga from './dashboard/sagas';
import faqsSaga from './faqs/sagas';
import fundingSearchSaga from './fundingSearch/sagas';
import fundingMatchSaga from './fundingMatch/sagas';
import fundingEnquirySaga from './fundingEnquiry/sagas';
import fundingReportSaga from './fundingReport/sagas';
import fundingSearchProfileSaga from './fundingSearchProfile/sagas';
import entityProfileSaga from './entityProfile/sagas';
import activitiesSaga from './activities/sagas';
import documentsSaga from './documents/sagas';
import urlModalTriggerSaga, { XeroModalTriggerSaga } from './UrlModalTriggers/sagas';
import leadSaga from './lead/sagas';
import learningSaga from './learning/sagas';
import teamsSaga from './teams/sagas';
import inviteSaga from './invite/sagas';
import teamsWizzardSaga from './teamsWizzard/sagas';
import companySaga from './company/sagas';
import monitorSaga from './monitor/sagas';
import postcoderSaga from './postcoder/sagas';
import userReportSaga from './userReport/sagas';
import membershipSaga from './membership/sagas';
import sseSaga from './sse/sagas';
import requestHelpSaga from './requestHelp/sagas';

export function* rootSaga() {
  yield all([
    userSaga(),
    lenderSaga(),
    notificationsSaga(),
    authSaga(),
    casesSaga(),
    dashboardSaga(),
    fundingSearchSaga(),
    fundingMatchSaga(),
    fundingEnquirySaga(),
    fundingReportSaga(),
    fundingSearchProfileSaga(),
    entityProfileSaga(),
    faqsSaga(),
    activitiesSaga(),
    documentsSaga(),
    urlModalTriggerSaga(),
    XeroModalTriggerSaga(),
    leadSaga(),
    learningSaga(),
    teamsSaga(),
    inviteSaga(),
    teamsWizzardSaga(),
    companySaga(),
    monitorSaga(),
    postcoderSaga(),
    userReportSaga(),
    membershipSaga(),
    sseSaga(),
    requestHelpSaga(),
  ]);
}
